import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "No se pudo iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] grid place-items-center px-4 py-12 bg-muted/30" data-testid="login-page">
      <div className="w-full max-w-md rounded-3xl border border-border bg-card p-8 sm:p-10">
        <div className="flex items-center gap-2 mb-8">
          <img src="/logo.png" alt="Colnexx" className="h-11 w-11 object-contain" />
          <div>
            <div className="font-display text-xl font-black tracking-tight">COLNEXX</div>
            <div className="text-xs text-muted-foreground flex items-center gap-1"><Lock className="h-3 w-3" /> Panel de administración</div>
          </div>
        </div>
        <h1 className="font-display text-2xl font-bold mb-1">Iniciar sesión</h1>
        <p className="text-sm text-muted-foreground mb-6">Acceso exclusivo para el equipo de Colnexx.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div className="space-y-2">
            <Label>Correo electrónico</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@colnexx.com" data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <Label>Contraseña</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full font-semibold gap-2 h-12" data-testid="login-submit">
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Ingresando...</> : <><ShieldCheck className="h-4 w-4" /> Ingresar</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
